<template>
  <div class="tcla-overview">
    <div class="tcla-cards-grid">
      <div class="tcla-card">
        <div class="tcla-card__value">{{ stats.totalPages }}</div>
        <div class="tcla-card__label">صفحه تحلیل‌شده</div>
      </div>
      <div class="tcla-card">
        <div class="tcla-card__value">{{ stats.avgSeoScore }}</div>
        <div class="tcla-card__label">میانگین امتیاز سئو</div>
      </div>
      <div class="tcla-card">
        <div class="tcla-card__value">{{ hubs.length }}</div>
        <div class="tcla-card__label">صفحه Hub</div>
      </div>
      <div class="tcla-card">
        <div class="tcla-card__value">{{ topicalClusters.length }}</div>
        <div class="tcla-card__label">خوشه موضوعی</div>
      </div>
    </div>

    <div class="tcla-panel">
      <h3 class="tcla-panel__title">📁 خوشه‌های موضوعی</h3>
      <div v-if="topicalClusters.length === 0" class="tcla-empty">خوشه‌ای یافت نشد</div>
      <div v-for="cluster in topicalClusters" :key="cluster.name" class="tcla-cluster-row">
        <div class="tcla-cluster-row__head">
          <strong>{{ cluster.name }}</strong>
          <span class="tcla-score-pill" :class="scoreClass(cluster.avgAuthority)">اقتدار {{ cluster.avgAuthority }}</span>
        </div>
        <div class="tcla-cluster-row__meta">
          {{ cluster.pageCount }} صفحه
          <span v-if="cluster.orphanCount">· {{ cluster.orphanCount }} یتیم</span>
          <span v-if="cluster.deadEndCount">· {{ cluster.deadEndCount }} بن‌بست</span>
        </div>
      </div>
    </div>

    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🧭 صفحات Hub</h3>
      <div v-if="hubs.length === 0" class="tcla-empty">صفحه Hub مشخصی شناسایی نشد</div>
      <div v-for="hub in hubs" :key="hub.url" class="tcla-cluster-row">
        <div class="tcla-cluster-row__head">
          <strong>{{ hub.title }}</strong>
          <span class="tcla-tag tcla-tag--blue">{{ hub.cluster }}</span>
          <span v-if="hub.isDeadEndHub" class="tcla-tag tcla-tag--err">بن‌بست!</span>
        </div>
        <div class="tcla-cluster-row__meta">
          امتیاز Hub: {{ hub.hubScore }} · خروجی {{ hub.actualOutgoing }}/{{ hub.expectedOutgoing }}
        </div>
      </div>
    </div>

    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🏅 صفحات برتر بر اساس امتیاز سئو</h3>
      <div class="tcla-score-table">
        <div class="tcla-score-row tcla-score-row--head">
          <span>صفحه</span><span>امتیاز</span><span>محتوا</span><span>اقتدار</span>
        </div>
        <div v-for="row in topPages" :key="row.url" class="tcla-score-row">
          <span class="tcla-score-row__title">{{ row.title }}</span>
          <span class="tcla-score-pill" :class="scoreClass(row.scores.seoScore)">{{ row.scores.seoScore }}</span>
          <span>{{ row.scores.contentQualityScore }}</span>
          <span>{{ row.scores.authorityScore }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAOverview',
  props: {
    articleReports: { type: Array, default: () => [] },
    topicalClusters: { type: Array, default: () => [] },
    hubs: { type: Array, default: () => [] }
  },
  computed: {
    stats() {
      const totalPages = this.articleReports.length;
      const avgSeoScore = totalPages
        ? Math.round(this.articleReports.reduce((s, a) => s + a.scores.seoScore, 0) / totalPages)
        : 0;
      return { totalPages, avgSeoScore };
    },
    topPages() {
      return [...this.articleReports]
        .sort((a, b) => b.scores.seoScore - a.scores.seoScore)
        .slice(0, 10)
        .map(a => ({ url: a.url, title: a.title, scores: a.scores }));
    }
  },
  methods: {
    scoreClass(score) {
      if (score >= 70) return 'tcla-score--good';
      if (score >= 40) return 'tcla-score--mid';
      return 'tcla-score--bad';
    }
  }
};
</script>

<style scoped>
.tcla-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 16px;
}
.tcla-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 18px 20px;
}
.tcla-card__value { font-size: 1.6rem; font-weight: 700; color: #1f2937; }
.tcla-card__label { font-size: 0.75rem; color: #9ca3af; margin-top: 4px; }

.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
  margin-bottom: 16px;
}
.tcla-panel__title { font-size: 0.92rem; font-weight: 700; margin: 0 0 14px 0; }
.tcla-empty { text-align: center; padding: 16px; color: #9ca3af; }

.tcla-cluster-row {
  border-bottom: 1px solid #f3f4f6;
  padding: 10px 0;
}
.tcla-cluster-row__head { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 4px; }
.tcla-cluster-row__meta { font-size: 0.78rem; color: #9ca3af; }

.tcla-score-table { display: flex; flex-direction: column; gap: 2px; font-size: 0.8rem; }
.tcla-score-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #f3f4f6;
  align-items: center;
  text-align: center;
}
.tcla-score-row--head { font-weight: 700; color: #9ca3af; font-size: 0.7rem; }
.tcla-score-row__title { text-align: right; }

.tcla-score-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.72rem;
}
.tcla-score--good { background: #d1fae5; color: #16a34a; }
.tcla-score--mid { background: #fef3c7; color: #d97706; }
.tcla-score--bad { background: #fee2e2; color: #ef4444; }

.tcla-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
}
.tcla-tag--blue { background: #dbeafe; color: #3b82f6; }
.tcla-tag--err { background: #fee2e2; color: #ef4444; }
</style>
